import { useContext, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom"
import ImageLoad from "./ImageLoad";
import { MyContext } from "../../Context/MyProvider";
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';

const Hire = () => {

    const { BaseUrl } = useContext(MyContext);

    const [step, setStep] = useState(1);
    const [partnerList, setPartnerList] = useState([]);
    const [selectData, setSelectData] = useState("");
    const [details, setDetails] = useState("")

    const Location = useLocation();
    const navigate = useNavigate();

    const handleGetDetails = (item) => {
        const uid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${BaseUrl}tcapi/s_partner_list.php`, { uid, cid: item?.cat_id })
            .then((res) => {
                setPartnerList(res.data.PartnerListData);
                setStep(2);
                setSelectData(item);
            })
            .catch((error) => {
                console.error("tcapi/s_partner_list.php", error);
            });
    }

    const handleNavigate = (id) => {
        const title = selectData.cat_name || selectData.title;
        navigate("/details", { state: { path: "/hire", name: "hire page", List: Location.state } });
        const LocalData = {
            title,
            cid: selectData.cat_id,
            sub_title: selectData.cat_subtitle,
            pid: id
        }
        secureLocalStorage.setItem("Productid", JSON.stringify(LocalData));
    }

    return (
        <div className="hire_page">
            <div className="width_container">
                <div className="">

                    {step === 1 && <div>
                        <h1 className="font-medium text-[20px] text-gray-700 max-_430_:text-[15px]">What service are you looking for ?</h1>
                        <div className="flex flex-wrap items-center gap-[30px] mt-[30px]">
                            {Location.state.map((item, index) => {
                                return <div key={index} onClick={() => handleGetDetails(item)} className="text-center cursor-pointer">
                                    <div className="w-[100px] h-[100px] mx-auto shadow bg-gray-100 rounded-full flex items-center justify-center">
                                        <ImageLoad BaseUrl={BaseUrl} url={item.cat_img} CustomeStyle={"mx-auto w-[40px] h-[40px] object-contain"} />
                                    </div>
                                    <p className="text-center text-[15px] mt-[10px]">{item.cat_name}</p>
                                </div>
                            })}
                        </div>
                    </div>}

                    {step === 2 && <div>

                        <div className="flex items-center gap-[10px]">
                            <button onClick={() => setStep(1)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.0001 12C22.0001 12.552 21.5531 13 21.0001 13H5.41413L10.7071 18.293C11.0981 18.684 11.0981 19.3161 10.7071 19.7071C10.5121 19.9021 10.2561 20 10.0001 20C9.74407 20 9.48804 19.9021 9.29304 19.7071L2.29401 12.708C2.20101 12.615 2.12797 12.5051 2.07697 12.3821C1.97597 12.1381 1.97597 11.862 2.07697 11.618C2.12797 11.495 2.20101 11.385 2.29401 11.292L9.29304 4.29301C9.68403 3.90201 10.3161 3.90201 10.7071 4.29301C11.0981 4.68401 11.0981 5.31607 10.7071 5.70707L5.41413 11H21.0001C21.5531 11 22.0001 11.448 22.0001 12Z" fill="#25314C" />
                                </svg>
                            </button>
                            <h1 className="font-medium text-[20px] text-gray-700 max-_430_:text-[15px] leading-5">Choose Best Recommendation from your near by!</h1>
                        </div>

                        <div className="flex flex-wrap items-center gap-[20px] mt-[30px]">
                            {partnerList.map((item, index) => {
                                return <div key={index} onClick={() => handleNavigate(item.id)} className="cart_box">
                                    <ImageLoad BaseUrl={BaseUrl} url={item.pimg} CustomeStyle={"mx-auto w-full h-[200px] object-contain"} />
                                    <div className="bg-white p-[10px] rounded-[10px] leading-5">
                                        <div className="flex items-center justify-between gap-[10px]">
                                            <h1 className="font-medium text-[17px] whitespace-nowrap overflow-hidden overflow-ellipsis">{item.name}</h1>
                                            <div className="flex items-center">
                                                <svg width="18" height="18" className="text-green-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                                </svg>
                                                <p className="text-[15px]">{item.rate}</p>
                                            </div>
                                        </div>
                                        <p className="text-[14px] text-gray-700 whitespace-nowrap overflow-hidden overflow-ellipsis">{item.city}</p>
                                        <button onClick={(e) => { e.stopPropagation(); setDetails(item) }} className='mt-[5px] w-full bg-black text-white text-[14px] py-[6px] rounded-[5px] font-medium'>View profile</button>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>}

                </div>
            </div>

            {details && <div onClick={() => setDetails("")} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} style={{ width: "450px", maxHeight: "80vh" }} className="bg-white p-[20px] rounded-[15px] overflow-hidden scroll_container_login">
                    <div className="flex items-center gap-[10px] mb-2">
                        <button onClick={() => setDetails("")}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.0001 12C22.0001 12.552 21.5531 13 21.0001 13H5.41413L10.7071 18.293C11.0981 18.684 11.0981 19.3161 10.7071 19.7071C10.5121 19.9021 10.2561 20 10.0001 20C9.74407 20 9.48804 19.9021 9.29304 19.7071L2.29401 12.708C2.20101 12.615 2.12797 12.5051 2.07697 12.3821C1.97597 12.1381 1.97597 11.862 2.07697 11.618C2.12797 11.495 2.20101 11.385 2.29401 11.292L9.29304 4.29301C9.68403 3.90201 10.3161 3.90201 10.7071 4.29301C11.0981 4.68401 11.0981 5.31607 10.7071 5.70707L5.41413 11H21.0001C21.5531 11 22.0001 11.448 22.0001 12Z" fill="black" />
                            </svg>
                        </button>
                        <h1 className='font-medium text-[20px]'>Export Profile</h1>
                    </div>
                    <div>
                        <ImageLoad BaseUrl={BaseUrl} url={details.pimg} CustomeStyle={"mx-auto w-[350px] h-[350px] object-contain"} />
                    </div>
                    <div className="mt-[10px]">
                        <div className="leading-5">
                            <h1 className='font-medium text-[20px]'>{details?.name}</h1>
                            <p className='text-[15px] text-gray-600'>{details?.cat_name}</p>
                        </div>
                        <div className="flex flex-wrap items-center justify-center gap-[10px] my-[10px]">
                            <div className="w-[150px] py-[15px] rounded-[10px] border border-gray-200 text-center bg-gray-100">
                                <p className='font-medium'>{details.total_earn}</p>
                                <p className='text-[15px] text-gray-600'>Total Earned</p>
                            </div>
                            <div className="w-[150px] py-[15px] rounded-[10px] border border-gray-200 text-center bg-gray-100">
                                <p className='font-medium'>{details.total_complete}</p>
                                <p className='text-[15px] text-gray-600'>Job Completed</p>
                            </div>
                        </div>

                        <div className="">
                            <h1 className='font-medium text-[18px]'>Bio</h1>
                            <p className='text-[14px] text-gray-600'>{details.bio}</p>
                        </div>
                    </div>
                </div>
            </div>}

        </div>
    )
}

export default Hire